const OnSearch = function(text) {
  this.collection.search_text = text
  this.collection.fetchData()
}
export default OnSearch